import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import Swal from 'sweetalert2';

const HeroSection = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  
  // Predefined list of routes and their labels
  const routes = [
    // Admin Routes
    { path: ' /sat/employee/employeeemployer', label: 'Adding Employer' },
    { path: '/sat/employee/employeeadminconsultant ', label: ' Adding Consultant' },
    { path: ' /sat/admin/adminviewEmployee', label: 'Managing Employer' },
    { path: '/sat/admin/adminviewconsultantdetails ', label: 'Managing Consultant ' },
    { path: '/sat/admin/adminrestrictEmployers ', label: 'View or Restrict Employers ' },
    { path: '/sat/admin/adminrestrictConsultants ', label: 'View or Restrict Consultants' },
    { path: '/sat/admin/managesubmissionsheets', label: 'View or Add Submission Sheets ' },
    { path: ' /sat/admin/adminmanagesatreports', label: 'Generate SAT Reports ' },
    { path: '/sat/admin/adminresumebuilder ', label: ' Open Resume Builder' },
    { path: '/sat/admin/adminairesumeanalyzer ', label: 'Learn How Resume Analyzer Works ' },
    { path: '/sat/admin/adminairesumematcher ', label: 'Learn How AI Resume Matcher Works' },
    { path: '/sat/admin/admintemplatesettings ', label: 'Change Template Settings ' },
    { path: ' /sat/admin/adminsavedjobs', label: 'View My Saved Jobs ' },
    { path: '/sat/admin/help-desk ', label: 'Access Help Desk' },
  
    // SuperAdmin Routes
    { path: '/sat/timesheet/manageConsultantssuperadmin ', label: 'Manage or Edit Consultants ' },
    { path: '/sat/employee/superadminadmin ', label: 'Adding the Admin ' },
    { path: '/sat/employee/superadminemployer ', label: 'Adding the Employer ' },
    { path: '/sat/timesheet/submissions-sheet ', label: ' View or Add Submission Sheets' },
    { path: '/sat/superadmin/emails ', label: 'Manage E-mails ' },
    { path: ' /sat/superadmin/emaillogs', label: ' E-mails Logs ' },
    { path: ' /sat/superadmin/schedulersettings', label: 'View Scheduler Logs ' },
    { path: ' /sat/superadmin/userandbillingoverview', label: ' View Billing Details' },
    { path: '/sat/superadmin/manageconsultantlicenses ', label: 'View My Licenses ' },
    { path: ' /sat/superadmin/manageorders ', label: 'View My Orders ' },
    { path: '/sat/superadmin/resumeBuilderGuide ', label: 'Use Resume Builder ' },
    { path: '/sat/superadmin/resumeAnalyzerGuide ', label: 'Learn How Resume Analyzer Works ' },
    { path: '/sat/superadmin/airesumematcher ', label: ' Learn How AI Resume Matcher Works ' },
    { path: '/sat/superadmin/savedResumes ', label: ' Saved Resumes ' },
    { path: ' /sat/superadmin/emailtemplateguide', label: 'Change Template Settings ' },
    { path: '/sat/superadmin/RestrictionLoginStatus ', label: 'Restriction Login Status ' },
    { path: '/sat/superadmin/AdminLoginStatus', label: ' Restriction Admin Login' },
    { path: '/sat/superadmin/ConsultantStatusManagement ', label: ' Consultant Status Management' },
    { path: '/sat/superadmin/AdminAccessManagement ', label: ' Admin Access Management ' },
    { path: '/sat/superadmin/AdminProfile ', label: 'Consultant Profile ' },
    { path: '/sat/superadmin/AssignLicensesToConsultant ', label: ' Assign Licenses To Consultant' },
    { path: ' /sat/superadmin/SATReportGuide', label: 'SAT Report Guide  ' },
  
    // Approver Manager Routes
    { path: '/time/approverManagers/profile ', label: 'View or Edit Your Profile ' },
    { path: '/time/approverManagers/addOrviewemployee ', label: '  Add or View Employee' },
    { path: '/time/approverManagers/addOrViewClient ', label: ' Add or View Client' },
    { path: '/time/approverManagers/project ', label: 'Create or Edit Project ' },
    { path: ' /time/approverManagers/timesheet', label: 'View All TimeSheets ' },
    { path: '/time/approverManagers/timesubmittedSheets ', label: ' View Submitted Sheets' },
    { path: '/time/approverManagers/approvedsheets ', label: ' View Approved Timesheets ' },
    { path: ' /time/approverManagers/pendingtimesheets', label: 'View Pending Sheets ' },
    { path: '/time/approverManagers/rejectedtimesheets ', label: 'View Rejected Sheets ' },
    { path: ' /time/approverManagers/recalledtimesheets', label: 'View Recalled Sheets ' },
          
      
    // Employee Routes
    { path: '/time/employee/profileemployee ', label: 'View or Edit Profile ' },
    { path: '/time/employee/timesheetsemployee ', label: 'TimeSheet ' },
    { path: '/time/employee/timesubmittedSheets ', label: 'View Submitted Sheets ' },
    { path: '/time/employee/approvedsheetsemployee ', label: ' View Approved Sheets ' },
    { path: '/time/employee/pendingtimesheets ', label: ' View Pending Sheets ' },
    { path: ' /time/employee/rejectedtimesheetsemployee', label: '  View Rejected Sheets' },
    { path: '/time/employee/recalledtimesheets ', label: ' View Recalled Sheets' },
    { path: '/time/employee/help-desk ', label: ' Help Desk' },
    
    // Consultant Routes
    { path: ' /sat/consultant/consultantprofile', label: 'View or Edit Profile ' },
    { path: ' /sat/consultant/managesubmissionsheets', label: 'View or Add Submission Sheets ' },
    { path: '/sat/consultant/managesatreports ', label: 'Generate SAT Reports ' },
    { path: '/sat/consultant/consultantresumebuilder ', label: 'Use Resume Builder ' },
    { path: ' /sat/consultant/consultantresumeanalyzer', label: 'Learn How Resume Analyzer Works ' },
    { path: '/sat/consultant/consultantairesumematcher ', label: 'Learn How AI Resume Matcher Works ' },
    { path: '/sat/consultant/consultantemailtemplateguide ', label: 'Change Template Settings ' },
    { path: '/sat/consultant/consultantsavedjobs ', label: ' View My Saved Jobs ' },
    { path: '/sat/consultant/help-desk', label: 'Access Help Desk ' },
  
    // TimeSheet and Miscellaneous Routes
    { path: ' /time/superadmin/superadminprofile', label: 'View or Edit Profile ' },
    { path: ' /time/superadmin/superadminapprovalmanager', label: ' View or Add Approval Manager' },
    { path: '/time/superadmin/superadminemployee ', label: 'View or Add Employee ' },
    { path: ' /time/superadmin/emaillogs', label: 'View or Add Client ' },
    { path: '/time/superadmin/superadminproject ', label: 'View or Create Project ' },
    { path: '/time/superadmin/superadminsubmittedsheets ', label: '  Submitted TimeSheets ' },
    { path: ' /time/superadmin/superadminapprovedsheets', label: ' View Approved TimeSheets' },
    { path: '/time/superadmin/superadminpendingsheets ', label: 'View Pending TimeSheets ' },
    { path: '/time/superadmin/superadminrejectedsheets ', label: 'View Rejected TimeSheets ' },
    { path: '/time/superadmin/superadminrecalledsheets ', label: 'View Recalled TimeSheets ' },
    { path: ' /time/superadmin/timesheetsettings', label: ' TimeSheet Settings' },
    { path: '/time/superadmin/organizationsettings ', label: '  Organization Settings ' },
    { path: '/time/superadmin/helpdesk ', label: ' HelpDesk' },

    // Account Help and Support Routes
    { path: '/sat/accounthelp/satreportgeneration', label: 'SAT Report Generation Help' },
    { path: '/sat/accounthelp/profileupdate', label: 'Update Profile Guide' },
    { path: '/sat/accounthelp/troubleshooting', label: 'Troubleshooting Guide' },

  // Employeer View User Profile
  { path: '/sat/employee/profile', label: 'View User Profile' },
  { path: '/sat/employee/employeeconsultant', label: 'Add Consultant' },
  { path: ' /sat/employee/employeesubmission', label: 'View Submission Sheets' },
  { path: ' /sat/employee/employeesat', label: 'Generate SAT Reports' },
  { path: ' /sat/employee/employerresumebuilder', label: 'Use Resume Builder' },
  { path: ' /sat/employee/employeeanalyzer', label: 'Learn How Resume Analyzer Works' },
  { path: ' /sat/employee/employeeaimatcher', label: 'Learn How AI Resume Matcher Works' },
  { path: ' /sat/employee/employeetemplate', label: 'Change Template Settings' },
  { path: ' /sat/employee/employeesavedjobs', label: 'My Saved Jobs' },
  { path: ' /sat/employee/help-desk', label: 'Help Desk' },

];
  // Update filtered routes based on search term
  useEffect(() => {
    if (searchTerm) {
      const matches = routes.filter(route =>
        route.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredRoutes(matches);
    } else {
      setFilteredRoutes([]);
    }
  }, [searchTerm]);

  return (
    <section className="hero">
      <h1> Welcome to Gatnix Support</h1>
      <div className="search-bar">
        <input
          type="text"
          placeholder="How can we help you?"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button>&#10132;</button>
      </div>

      {/* Display matching routes */}
      <div className='search-results_search'>
      {filteredRoutes.length > 0 && (
        <div className="search-results">
          <ul>
            {filteredRoutes.map((route, index) => (
              <li key={index}  className='liststyle'>
                <Link to={route.path}>{route.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      )}
      </div>

      {/* Show no results message */}
      {searchTerm && filteredRoutes.length === 0 && (
        <p className="no-results">No matching topics found.</p>
      )}
    </section>
  );
};

export default HeroSection;
